export default "__VITE_ASSET__DmBPvd0W__"